module.exports = __webpack_public_path__ + "img/case-logo-27.419ba35a.png";